import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User entered full screen mode',
  name: 'entered_full_screen',
  params: [
    {
      description: 'The context where full screen was entered',
      name: 'location',
      required: false,
      type: 'enum',
      values: ['pdf', 'video'],
    },
  ],
};

export default META;
